/* TESTE DE PREÇO A/B/C DA LIPLEGGING (VWO, out/2026). Ver snippets/tp-teste-preco.liquid.

   O núcleo (grupo, tabela, preco(), ajustarOferta()) nasce no <head>. Este arquivo faz o resto:

   1. PREÇO NOS CARDS E MENUS: o preço que vem pronto do Liquid (card da coleção, menu, sugestões da
      gaveta vazia, produtos relacionados) é trocado no texto. Só troca o número que está na tabela
      (R$ 359,90 / R$ 379,90, e a parcela "3x de R$ 119,96" que sai deles) e só quando o elemento pertence a uma peça do teste: o ancestral mais
      próximo que tem link de produto precisa apontar SÓ para peças do teste. A caixa de compra e a
      compra rápida não passam por aqui: elas perguntam o preço ao núcleo.
   2. CARRINHO: grava o atributo _tp_preco = grupo, que é o que a Function lê para cobrar o preço do
      grupo. Confere ao abrir a página, depois de cada /cart/add e antes de ir para o checkout
      (a cliente nunca chega ao checkout com o preço da tela diferente do cobrado).
   ES5 de propósito, como o resto do tema. */
(function () {
  'use strict';
  var api = window.tpTestePreco;
  if (!api) return;
  var HANDLES = (api.cfg && api.cfg.handles) || [];

  /* ---------- 1. preço que vem pronto no HTML ---------- */
  function brl(c) { return (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function handleDe(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); return m ? m[1] : null; }
  // peça do teste dona deste elemento, ou null
  function donoDe(el) {
    for (var p = el; p && p !== document.body; p = p.parentElement) {
      if (p.matches && p.matches('a[href*="/products/"]')) { var h = handleDe(p); return HANDLES.indexOf(h) > -1 ? h : null; }
      var links = p.querySelectorAll ? p.querySelectorAll('a[href*="/products/"]') : [];
      if (links.length) {
        // card que também leva a outra peça (look, "combine com") não é só da LipLegging: fica como está
        for (var i = 0; i < links.length; i++) if (HANDLES.indexOf(handleDe(links[i])) < 0) return null;
        return handleDe(links[0]);
      }
    }
    return null;
  }
  var trocas = null; // [{ de: '359,90', por: '329,90', re: RegExp }]
  // Parcela do card ("3x de R$ 119,96 sem juros", tp-installments): "Nx|valor" -> valor do grupo.
  // Mesma conta do tema: arredonda para baixo (ver parcela() em tp-oferta-b.js).
  var parcelas = {}, RE_PARCELA = /(\d{1,2}) ?x de R\$ ?(\d{1,3}(?:\.\d{3})*,\d{2})/g, TEM_PARCELA = /\d ?x de R\$/;
  function montaTrocas() {
    trocas = []; parcelas = {};
    var t = api.tabela;
    if (!t) return;
    for (var de in t) {
      var deTxt = brl(+de);
      trocas.push({ de: deTxt, por: brl(t[de]), re: new RegExp('(^|[^\\d.,])' + deTxt.replace(/[.]/g, '\\.') + '(?!\\d)', 'g') });
      for (var n = 2; n <= 12; n++) parcelas[n + '|' + brl(Math.floor(+de / n))] = brl(Math.floor(t[de] / n));
    }
  }
  function trocaTexto(no) {
    var s = no.nodeValue, novo = s;
    for (var i = 0; i < trocas.length; i++) {
      if (novo.indexOf(trocas[i].de) < 0) continue;
      novo = novo.replace(trocas[i].re, '$1' + trocas[i].por);
    }
    if (TEM_PARCELA.test(novo)) {
      novo = novo.replace(RE_PARCELA, function (tudo, n, valor) {
        var por = parcelas[n + '|' + valor];
        return por ? tudo.replace(valor, por) : tudo;
      });
    }
    if (novo === s) return;
    var el = no.parentElement;
    if (!el || el.closest('script,style,textarea,[data-tp-ob],[data-tp-preco-ignorar]')) return;
    if (!donoDe(el)) return;
    no.nodeValue = novo; // o número novo não está na tabela: o observer não troca de novo
  }
  // Grupo "semRiscado" (UTM da Meta): o "de" riscado e o selo -X% das peças do grupo somem (card, menu,
  // gaveta), para o preço novo aparecer como preço normal. A caixa de compra e a compra rápida já
  // desenham sem riscado (compare zerado em ajustarOferta / mostrarPreco).
  var RISCADO = 's, del, .tp-pcf__off, .price__badge-sale';
  function escondeRiscados(raiz) {
    if (!api.semRiscado() || !raiz.querySelectorAll) return;
    var lista = [].slice.call(raiz.querySelectorAll(RISCADO));
    if (raiz.matches && raiz.matches(RISCADO)) lista.push(raiz);
    lista.forEach(function (el) {
      if (el.style.display === 'none' || el.closest('[data-tp-ob],[data-tp-preco-ignorar]') || !donoDe(el)) return;
      el.style.display = 'none';
      // o preço ao lado perde a cor de promoção (tp-pcf__price-main--sale, price--on-sale do Dawn)
      var pai = el.closest('.price') || el.parentElement;
      if (pai) {
        pai.classList.remove('price--on-sale');
        [].forEach.call(pai.querySelectorAll('[class*="--sale"]'), function (x) {
          x.className = x.className.replace(/\S+--sale\b/g, '').trim();
        });
      }
    });
  }
  function varre(raiz) {
    if (!trocas || !trocas.length || !raiz) return;
    if (raiz.nodeType === 3) { trocaTexto(raiz); return; }
    if (raiz.nodeType !== 1 && raiz.nodeType !== 9) return;
    escondeRiscados(raiz);
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null, false), n, achados = [];
    while ((n = w.nextNode())) {
      if (TEM_PARCELA.test(n.nodeValue)) { achados.push(n); continue; }
      for (var i = 0; i < trocas.length; i++) if (n.nodeValue.indexOf(trocas[i].de) > -1) { achados.push(n); break; }
    }
    achados.forEach(trocaTexto);
  }
  // cards novos (filtro, "carregar mais", gaveta redesenhada, troca de cor no card) chegam depois
  var pendentes = [], agendado = false;
  function agenda(no) {
    pendentes.push(no);
    if (agendado) return;
    agendado = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      agendado = false;
      var lote = pendentes; pendentes = [];
      lote.forEach(varre);
    });
  }
  var obs = new MutationObserver(function (lista) {
    if (!trocas || !trocas.length) return;
    lista.forEach(function (m) {
      if (m.type === 'characterData') agenda(m.target);
      else for (var i = 0; i < m.addedNodes.length; i++) agenda(m.addedNodes[i]);
    });
  });

  /* ---------- 2. atributo do carrinho ---------- */
  var fetchOrig = window.fetch.bind(window), emCurso = null;
  function json(r) { return r.json(); }
  function sincroniza() {
    var g = api.grupo;
    if (!g) return Promise.resolve();
    if (emCurso) return emCurso;
    emCurso = fetchOrig('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json).then(function (c) {
      if (c && c.attributes && c.attributes._tp_preco === g) return;
      return fetchOrig('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _tp_preco: g } })
      });
    }).catch(function () { }).then(function () { emCurso = null; });
    return emCurso;
  }
  // checkout: segura o clique até o atributo estar gravado, depois clica de novo
  var liberado = false;
  function seguraCheckout(e) {
    if (liberado || !api.grupo) return;
    var bt = e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (!bt) return;
    e.preventDefault(); e.stopPropagation();
    sincroniza().then(function () { liberado = true; bt.click(); setTimeout(function () { liberado = false; }, 1500); });
  }

  /* ---------- liga ---------- */
  // Quem não está no teste (sem grupo, ou o controle) não ganha nada disto: nem observer, nem
  // fetch embrulhado, nem trava no checkout. O site roda exatamente como antes para essa cliente.
  var ligado = false;
  function liga() {
    if (ligado) return;
    ligado = true;
    var fetchAntes = window.fetch; // o que estiver valendo agora (pixel/VWO podem ter embrulhado antes)
    window.fetch = function (input) {
      var p = fetchAntes.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (api.grupo && url.indexOf('/cart/add') > -1) p.then(function () { sincroniza(); }, function () { });
      } catch (e) { }
      return p;
    };
    document.addEventListener('click', seguraCheckout, true);
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  // Grupo velho preso no carrinho: no iPhone o Safari apaga o grupo do navegador (e o sorteio do VWO)
  // em ~7 dias sem visita, mas o carrinho fica no servidor. Se agora a cliente não tem grupo (ou caiu
  // no controle), tira o do carrinho, senão o checkout cobraria o preço do grupo antigo. Só faz a
  // chamada quando o Liquid viu um grupo no carrinho; para o resto, nada.
  function limpaCarrinhoVelho() {
    if (!api.noCarrinho || api.grupo === api.noCarrinho) return;
    api.noCarrinho = '';
    fetchOrig('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _tp_preco: '' } })
    }).catch(function () { });
  }
  function aplica() {
    if (!api.grupo || !api.tabela) { limpaCarrinhoVelho(); return; }
    montaTrocas();
    liga();
    varre(document.body);
    sincroniza();
  }
  // grupo que o VWO definiu depois de a página abrir (a caixa de compra se redesenha sozinha)
  document.addEventListener('tp:teste-preco', aplica);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplica); else aplica();
})();
